import rdDomMessageTemplate from '../../templates/dialog/RDTheme/message_template.ejs'
import rdPlusDomMessageTemplate from '../../templates/dialog/RDPlusTheme/message_template.ejs'

const createMessageTemplateFactory = (message) => {
    let domMessageTemplate;
    if (ApexChat.IsRoundedDynamicPlusTheme) {
        domMessageTemplate = rdPlusDomMessageTemplate(message);
    } else {
        domMessageTemplate = rdDomMessageTemplate(message);
    }

    return {
        domMessageTemplate,
    };
};
export default createMessageTemplateFactory;
